import { Navigate } from "react-router-dom";
import { AdminContainer } from "@src/pages/administrator/adminContainer";
import { DashboardPage } from "@src/pages/administrator/dashboard";
import { adminLoader } from "../loaders/index";
import Protected from "./Protected";
import DynamicContentPage from "@src/pages/administrator/dynamicContent/page";
import CustomersPage from "@src/pages/administrator/customers/page";
import CustomerDetailsPage from "@src/pages/administrator/customerDetails/page";
import BehavioursPage from "@src/pages/administrator/behaviours/page";
import UsersPage from "@src/pages/administrator/users/page";
import { BehiveGridLayoutEditorPage } from "@src/pages/administrator/BehiveGridLayoutEditor/BehiveGridLayoutEditorPage";
import UserDetailsPage from "@src/pages/administrator/userDetails/page";
import NotificationTemplatesPage from "@src/pages/administrator/notificationTemplates/page";
import AdvancedPage from "../pages/administrator/advanced/page";

const adminRootLoader = async (req) => {
  return {
    // dict of promises so we can display loading screen
    initialData: adminLoader(req), // required
    //nonCriticalData: ...
  };
};

export const adminRoutes = {
  path: "admin",
  loader: adminRootLoader,
  element: (
    <Protected allowedUserType={"admin"}>
      <AdminContainer />
    </Protected>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="overview" />,
    },
    {
      path: "overview",
      pageTitle: "Impersonate",
      menuIcon: "searchCircle",
      menuIconActive: "searchCircleFilled",
      element: <DashboardPage />,
    },
    {
      path: "customers",
      pageTitle: "Customers",
      menuIcon: "building",
      menuIconActive: "buildingFilled",
      element: <CustomersPage />,
    },
    {
      path: "customers/:customerId",
      element: <CustomerDetailsPage />,
    },
    {
      path: "behaviours",
      pageTitle: "Behaviours",
      menuIcon: "bolt",
      menuIconActive: "boltFilled",
      element: <BehavioursPage />,
    },
    {
      path: "users",
      pageTitle: "Operators",
      menuIcon: "user",
      menuIconActive: "userFilled",
      element: <UsersPage />,
    },
    {
      path: "users/:operatorId",
      element: <UserDetailsPage />,
    },
    {
      separator: true,
    },
    {
      path: "dynamiccontent",
      pageTitle: "Dynamic Content",
      menuIcon: "editPen",
      menuIconActive: "editPenFilled",
      element: <DynamicContentPage />,
    },
    {
      path: "BehiveGridLayoutEditorPage",
      pageTitle: "Behive Grid Layout Editor",
      menuIcon: "layouts",
      menuIconActive: "layoutsFilled",
      element: <BehiveGridLayoutEditorPage />,
    },
    {
      path: "notification-templates",
      pageTitle: "Notification Templates",
      menuIcon: "bellOutline",
      menuIconActive: "bellFilled",
      element: <NotificationTemplatesPage />,
    },
    {
      path: "advanced",
      pageTitle: "Advanced",
      menuIcon: "cogOutline",
      menuIconActive: "cogFilled",
      element: <AdvancedPage />,
    },
  ],
};
